import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { BaseCalc } from "../../baseCalc";
import React from "react";
import { OnlineSkeleton } from "./onlineSkeleton";
// Добавляем webpackChunkName для правильной именованной загрузки чанка
var OnlineLayout = React.lazy(function () { return import(/* webpackChunkName: "online-layout" */ "./onlineLayout"); });
export var OnlineCalculator = function (_a) {
    var esiaLink = _a.esiaLink, context = _a.context;
    return (_jsx("div", { id: "calculator-block", children: _jsx(Suspense, { fallback: _jsx(OnlineSkeleton, {}), children: _jsx(BaseCalc, { esiaLink: esiaLink, Layout: OnlineLayout, context: context }) }) }));
};
